<template>
  <div v-if="this.envData && this.envData.envEachList && this.envData.envEachList.length > 1">
    <span>
      {{ this.envData.completeRate }}% ({{$t('$건 중 $건 완료', $store.state.settings.lang == 'en' ? [this.envData.completeCnt, this.envData.envCnt] : [this.envData.envCnt, this.envData.completeCnt])}})
    </span>
  </div>
  <div v-else class="parti_list symbol-group symbol-hover flex-nowrap" :class="'parti_list_' + this.modeData">
    <div v-for="(parti, i) in this.partiDatas" :key="i" class="symbol symbol-25px symbol-circle">
      <span v-if="parti.confStatusCd == 'CONF'" :class="'symbol-label fw-bold bg-' + parti.confStatusClass + ' text-inverse-' + parti.confStatusClass">
        <b-icon v-if="parti.confStatusCd == 'CONF'" icon="check" font-scale="1.3"></b-icon>
      </span>
      <span v-else class="symbol-label fw-bold bg-secondary text-inverse-secondary">
        {{ parti.sort }}
      </span>
      <span class="symbol-text cursor-help" :id="'envPartiGrp_'.concat(parti.envNo, '_', parti.envSeq, '_', parti.partiNo)" :data-n="parti.partiNo">
        <span v-if="modeData == 'col'" class="fw-bold">{{ parti.roleNm }}</span>
        <span>{{ parti.partiNm || parti.grpNm || parti.roleNm }}</span>
        <span v-if="modeData == 'col'">{{ parti.partiEmail }}</span>
      </span>
      <b-tooltip triggers="hover" placement="bottom"
        :target="'envPartiGrp_'.concat(parti.envNo, '_', parti.envSeq, '_', parti.partiNo)">
        <div class="text-left me-7">
          <div v-if="parti.partiGrpList.length == 0" class="my-2 d-flex align-items-center">
            <span>{{parti.partiNm || parti.grpNm || parti.roleNm}} ({{parti.partiEmail}})</span>
            <span v-if="parti.confStatusCd == 'CONF'" class="text-muted ms-2">{{ parti.confStatusDt ? parti.confStatusDt.f('datetime-local') : '' }}</span>
          </div>
          <div v-else>
            <div v-for="(partiGrp, j) in parti.partiGrpList" :key="j">
              <b class="mt-2 mb-1">{{partiGrp.grpNm}}</b>
              <ul class="list-unstyled ps-2">
                <li v-for="(partiEach, k) in partiGrp.partiEachList" :key="k" class="my-1 ps-2 d-flex">
                  <span>{{partiEach.partiNm}} ({{partiEach.partiEmail}})</span>
                  <span v-if="partiEach.partiEmail == parti.partiEmail" class="text-muted ms-2">{{ parti.confStatusDt ? parti.confStatusDt.f('datetime-local') : '' }}</span>
                  <b-icon v-if="partiEach.partiEmail == parti.partiEmail" icon="check" variant="success" class="fs-3 ms-2" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </b-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    env: {},
    partiList: [],
    mode: '',
  },
  data: () => ({
    envData: {},
    partiDatas: [],
    modeData: 'row'
  }),
  mounted() {
    if(this.env) this.envData = this.env;
    if(this.partiList) this.partiDatas = this.partiList;
    if(this.mode) this.modeData = this.mode;
  },
  methods: {
  },
};
</script>

<style scoped>
.parti_list  {
  display: flex;
  flex-wrap: wrap !important;
  margin: 0 !important;
  justify-content: flex-start;  
}

.parti_list .symbol-label {
  font-size: 11px;
}

.parti_list > .symbol::before {
  content: "";
  position: absolute;
  z-index: -1;
}

.parti_list > .symbol:last-child::before {
  border: none;
}

.parti_list_row {
  flex-direction: row !important;
  min-width: 200px;
  max-width: 300px;
}

.parti_list_row > .symbol {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  margin: 4px 4px 0 4px;  
}

.parti_list_row > .symbol::before {
  border-top: 1px dashed #DBDFE9;
  top: 12px;
  left: 40px;
  right: -20px;
}

.parti_list_row .symbol-text {
  display: flex;
  flex-direction: column;
  justify-content: center; 
  padding-top: 2px;
  width: 52px;
  text-align: center;
}

.parti_list_col {
  flex-direction: column !important;
}

.parti_list_col > .symbol {
  display: inline-flex;
  flex-direction: row;
  align-self: stretch;
  align-items: flex-start;
  margin-bottom: 20px;
}

.parti_list_col > .symbol::before {
  border-left: 1px dashed #DBDFE9;
  top: 25px;
  bottom: -30px;
  left: 12px;
}

.parti_list_col .symbol-text {  
  display: flex;
  flex-direction: column;
}

.parti_list_col .symbol-label {
  margin-right: 10px;
}
</style>